import React from 'react';
import {
  Nav,
  NavList,
  NavListItem,
  NavLink,
  /* ColorModeSwitcher, */
  Button
} from 'smooth-doc/components';
import { x } from '@xstyled/styled-components';
import { useSidenavDialog } from '../context/SidenavDialogContext';

export function AppNav() {
  const dialog = useSidenavDialog();

  return (
    <Nav fontFamily="cabin" lineHeight="none" fontSize="sm">
      <NavList>
        <NavListItem padding="0">
          <NavLink
            display={{ xs: 'none', lg: 'block' }}
            as="a"
            href="https://www.axiomatics.com/contact-us/"
            target="_blank"
          >
            <Button p="3 4" fontSize="sm" borderRadius="6" fontWeight="bold">
              Contact Us
            </Button>
          </NavLink>
        </NavListItem>
        <NavListItem ml="2" display={{ lg: 'none' }}>
          <x.button
            background="transparent"
            css={{
              '&:focus': {
                outline: 'none'
              }
            }}
            onClick={() => dialog.toggle()}
            fontSize={{ xs: 20, lg: 24 }}
          >
            {dialog.visible ? (
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 18H16V16H3V18ZM3 13H13V11H3V13ZM3 6V8H16V6H3ZM21 15.59L17.42 12L21 8.41L19.59 7L14.59 12L19.59 17L21 15.59Z"
                  fill="#4CA48A"
                />
              </svg>
            ) : (
              <svg
                width="1em"
                height="1em"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z"
                  fill="#4CA48A"
                />
              </svg>
            )}
          </x.button>
        </NavListItem>
        {/* <NavListItem mx="2">
          <NavLink as={ColorModeSwitcher} />
        </NavListItem> */}
      </NavList>
    </Nav>
  );
}
